import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Equalizer from './Equalizer';

export const RADIO_RENDERER_TYPE = '@sportsbook/radio';

const Radio = ({ label, playingLabel, muted, withIcon = true, animationOn = false, onEqualizerClick }) => (
  <span className="radio" data-test-id={`${RADIO_RENDERER_TYPE}.radio-panel`}>
    {withIcon && playingLabel && (
      <span
        className={cx(
          {
            'radio__icon--muted': muted,
          },
          'radio__icon'
        )}
      >
        <Equalizer
          onClick={(e) => {
            e.stopPropagation();
            onEqualizerClick();
          }}
        />
      </span>
    )}
    <span className="radio__label">
      <span className={cx({ radio__marquee: animationOn })}>
        {playingLabel && !animationOn ? `Playing: ${playingLabel}` : label}
      </span>
    </span>
  </span>
);

Radio.propTypes = {
  label: PropTypes.string,
  playingLabel: PropTypes.string,
  muted: PropTypes.bool,
  withIcon: PropTypes.bool,
  animationOn: PropTypes.bool,
  onEqualizerClick: PropTypes.func,
};

export default Radio;
